import {
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@design-system/shadcn";
import { ChevronDown, ListFilter } from "lucide-react";
import React from "react";

import { useFiltersContext } from "./data-table-filters-context";

interface DataTableFiltersManagerProps {
  label?: string;
}

function FiltersManager({ label = "Filters" }: DataTableFiltersManagerProps) {
  const {
    state: { fields, visibleFieldIds },
    actions: { showField, hideField },
  } = useFiltersContext();

  // A field that is always on the row would get a toggle that does nothing.
  const manageableFields = fields.filter((field) => field.removable);
  if (manageableFields.length === 0) return null;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="default">
          <ListFilter aria-hidden />
          {label}
          <ChevronDown aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {manageableFields.map((field) => (
          <DropdownMenuCheckboxItem
            key={field.id}
            // Radix dismisses a menu on select; toggling visibility is not a
            // "choose one and leave" action, and the Columns surface beside this
            // one already stays open.
            onSelect={(event) => event.preventDefault()}
            checked={visibleFieldIds.includes(field.id)}
            onCheckedChange={(checked) =>
              checked ? showField(field.id) : hideField(field.id)
            }
          >
            {field.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { FiltersManager };
export type { DataTableFiltersManagerProps };
